import { z } from 'zod';
export var PublishedWorkoutStatusDomain;
(function (PublishedWorkoutStatusDomain) {
    PublishedWorkoutStatusDomain.Module = 'PublishedWorkoutStatus';
    const module = z.literal(PublishedWorkoutStatusDomain.Module);
    PublishedWorkoutStatusDomain.CancelBlockWorkout = z.object({
        module,
        type: z.literal('CancelBlockWorkout'),
        input: z.object({
            blockId: z.uuid(),
            workoutId: z.uuid(),
        }),
    });
    PublishedWorkoutStatusDomain.UpdateAthleteWorkoutStatus = z.object({
        module,
        type: z.literal('UpdateAthleteWorkoutStatus'),
        input: z.object({
            blockId: z.uuid(),
            workoutId: z.uuid(),
            timezone: z.string().optional(),
            updates: z.array(z.object({
                profileId: z.uuid(),
                status: z.enum(['completed', 'skipped', 'canceled', 'planned']),
                // Can't type this as Workout because of cyclical dependency with @strength/domain-workout
                workout: z.any().optional(),
            })),
        }),
    });
})(PublishedWorkoutStatusDomain || (PublishedWorkoutStatusDomain = {}));
//# sourceMappingURL=domain.js.map